module.exports = __webpack_public_path__ + "img/linked_in_logo.0e38ce59.svg";